import changeCase from 'change-case';
import _ from 'lodash';

export default function(
  pathname,
  chapterSlugToObjectMap,
  chapterIntroSlugToObjectMap,
  lessonSlugToObjectMap
) {
  const parts = _.compact(pathname.split('/'));
  const chapter = chapterSlugToObjectMap[parts[1]];

  if (parts.length === 0) {
    return 'Home';
  } else if (parts.length === 1) {
    return changeCase.titleCase(parts[0]);
  } else if (parts.length === 2 && parts[0] === 'learn') {
    return `Chapter ${chapter.displayOrder}`;
  } else if (parts.length === 2) {
    return `${changeCase.titleCase(parts[0])}, ${changeCase.titleCase(
      parts[1]
    )}`;
  } else if (
    parts.length === 4 &&
    parts[0] === 'learn' &&
    parts[2] === 'pages'
  ) {
    const introPage = chapterIntroSlugToObjectMap[parts[3]];
    return introPage.isReview
      ? `Chapter ${chapter.displayOrder}, Review`
      : `Chapter ${chapter.displayOrder}, Intro ${introPage.displayOrder}`;
  } else if (
    parts.length === 6 &&
    parts[0] === 'learn' &&
    parts[2] === 'lessons'
  ) {
    const lesson = lessonSlugToObjectMap[parts[3]];
    return `Chapter ${chapter.displayOrder}, Lesson ${lesson.displayOrder}, Part ${parts[5]}`;
  } else if (
    parts.length === 6 &&
    parts[0] === 'discharge' &&
    parts[2] === 'lessons'
  ) {
    return `Discharge Pathway, ${changeCase.titleCase(
      parts[3]
    )}, Part ${parts[5]}`;
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/helpers/formatPathname.js